import { useForm } from "react-hook-form";
import usePartAspectsMutations from "../../data/usePartAspectsMutations";
import { ButtonInput } from "../shared/Inputs/ButtonInput";
import { CheckboxInput } from "../shared/Inputs/CheckboxInput";
import { TextInput } from "../shared/Inputs/TextInput";
import { IPartAspect } from './../../models/EbayOffer';
import useDefaultCRUDHandlers from "../../hooks/useDefaultCRUDHandlers";

interface newAspectFormValues {
  id: string | null;
  partCategoryDefaultsId: string | null;
  name: string;
  options: string | null;
  isRequired: boolean;
}

export default function SingleCategoryCustomAspect({ aspect }: { aspect: IPartAspect }) {
  const { createUpdateCategoryDefaults, remove } = usePartAspectsMutations();
  const { saveHandlers, deleteHandlers } = useDefaultCRUDHandlers("Category Default Aspect");

  const { register, reset, handleSubmit } = useForm<newAspectFormValues>({
    defaultValues: {
      ...aspect,
    }
  });

  const onSubmit = (data: newAspectFormValues) => {
    const newAspect = {
      ...data,
    };

    createUpdateCategoryDefaults.mutate(newAspect, {
      ...saveHandlers,
      onSuccess: () => {
        reset(data);
      }
    });
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} key={aspect.id} className="grid grid-cols-4 gap-x-4 items-center border-0 border-b pb-4">
      <div className="flex items-center">
        <label className="font-medium text-gray-500">{aspect.name}</label>
      </div>

      <TextInput
        label="Options (comma separated)"
        register={register}
        registerName={`options`}
      />

      <CheckboxInput
        label="Required?"
        register={register}
        registerName={"isRequired"}
      />
      <div>
        <ButtonInput
          label="Update"
          isSubmit
          onClick={undefined}
          classes={undefined}
          isLoading={createUpdateCategoryDefaults.isLoading}
        />

        <ButtonInput
          label="Delete"
          onClick={() => remove.mutate(aspect.id, deleteHandlers)}
          classes="ml-2 bg-red-500 hover:bg-red-600"
          isLoading={remove.isLoading}
        />
      </div>
    </form>
  )
}